<script lang="ts">
    import { getJetPerform } from '~/jet';
    import { getI18n } from '~/stores/i18n';

    // Shared components
    import LatestReleaseLockup from '@amp/web-app-components/src/components/lockups/LatestReleaseLockup/LatestReleaseLockup.svelte';

    // Components
    import ButtonAction from '~/components/jet/action/ButtonAction.svelte';
    import ClickAction from '~/components/jet/action/ClickAction.svelte';
    import StaticPlayButton from '~/components/jet/buttons/StaticPlayButton.svelte';

    const i18n = getI18n();
    const perform = getJetPerform();

    export let item: any;

    const handleArtworkClick = () => perform(item.segue);
</script>

<LatestReleaseLockup
    lockup={item}
    dragEnabled={false}
    isContainer={false}
    isVideo={false}
    isEditorsChoice={true}
    on:artworkClick={handleArtworkClick}
>
    <svelte:fragment slot="title">
        <ClickAction action={item.segue}>
            {item.title}
        </ClickAction>
    </svelte:fragment>

    <svelte:fragment slot="play-button">
        {#if item.playAction}
            <StaticPlayButton
                playAction={item.playAction}
                ariaLabel={''}
                isInChin={false}
            />
        {/if}
    </svelte:fragment>

    <svelte:fragment slot="buttons">
        {#if item.playAction}
            <ButtonAction
                action={item.playAction}
                title={$i18n.t('ASE.Web.MusicClassical.Play')}
                styleOverride={{
                    isPlay: true,
                    isSecondary: true,
                    isPill: true,
                }}
            />
        {/if}
    </svelte:fragment>
</LatestReleaseLockup>
